var StyleBean = /** @class */ (function () {
    function StyleBean() {
        this.masterId = '';
        this.colorCode = '';
        this.description = '';
        this.colorName = '';
        this.seasonCode = '';
        this.colorBlocked = 0;
        this.currencyCode = 'EUR';
        this.gots = '';
        this.oekotex = '';
        this.organic = false;
        this.ecovero = false;
        this.whp = 0;
        this.msrp = 0;
        this.totalDisp = 0;
        this.collectionName = '';
        this.navCollection = '';
        this.orderType = '';
        this.recycled = false;
        this.b2BColorComment = '';
        this.b2BMasterComment = '';
        this.priceType = 'NoDiff';
        this.colorNote = '';
        this.customerPrice = 0;
        this.ocsno = '';
        this.grsno = '';
        this.ocsblended = '';
        this.totalcolorsold = 0;
        this.totalmastersold = 0;
        this.qtysbbaskets = 0;
        this.qtyb2bbaskets = 0;
    }
    StyleBean.prototype.getWHPWithDiscount = function (discount) {
        discount = discount || 0;
        return this.whp - (this.whp * (discount / 100));
    };
    StyleBean.build = function (data, type) {
        var bean = new StyleBean();
        switch (type) {
            case 'moloItem':
                var moloItem = data;
                bean.masterId = moloItem.masterId;
                bean.colorCode = moloItem.colorCode;
                bean.description = moloItem.description;
                bean.colorName = moloItem.colorName;
                bean.seasonCode = moloItem.seasonCode;
                bean.colorBlocked = moloItem.colorBlocked;
                bean.gots = moloItem.gots || '';
                bean.oekotex = moloItem.oekoTex || '';
                bean.whp = moloItem.whp;
                bean.msrp = moloItem.msrp;
                bean.priceType = moloItem.priceType;
                bean.customerPrice = moloItem.customerPrice;
                bean.ocsblended = moloItem.ocsblended;
                bean.discontinued = moloItem.discontinued;
                break;
            case 'style':
                // const randomNumber = Math.floor(Math.random() * 11);  
                var style = data;
                if (!style) {
                    return bean;
                }
                bean.totalcolorsold = style.totalcolorsold;
                bean.totalmastersold = style.totalmastersold;
                bean.qtysbbaskets = style.qtysbbaskets;
                bean.qtyb2bbaskets = style.qtyb2bbaskets;
                bean.masterId = style.masterId;
                bean.colorCode = style.colorCode;
                bean.description = style.description;
                bean.colorName = style.colorName;
                bean.seasonCode = style.seasonCode;
                bean.colorBlocked = style.colorBlocked;
                bean.currencyCode = style.currencyCode;
                bean.deliveryWindow = style.deliveryWindow;
                bean.fabricComposition = style.fabricComposition;
                bean.styleNote = style.styleNote;
                bean.gots = style.gots || '';
                bean.priceType = style.priceType;
                bean.organic = style.organic;
                bean.ecovero = style.ecovero;
                bean.oekotex = style.oekotex || '';
                bean.styleComment = style.styleComment || '';
                bean.colorComment = style.colorComment || '';
                bean.whp = style.whp;
                bean.msrp = style.msrp;
                bean.totalDisp = style.totalDisp;
                bean.collectionName = style.collectionName;
                bean.navCollection = style.navCollection;
                bean.orderType = style.orderType;
                bean.recycled = style.recycled;
                bean.b2BColorComment = style.b2BColorComment;
                bean.b2BMasterComment = style.b2BMasterComment;
                bean.colorNote = style.colorNote;
                bean.ocsno = style.ocsno || '';
                bean.grsno = style.grsno || '';
                bean.discontinued = style.discontinued;
                break;
            case 'orderLine':
                var orderLine = data;
                bean.masterId = orderLine.masterId;
                bean.colorCode = orderLine.colorCode;
                bean.description = orderLine.description;
                bean.colorName = orderLine.colorName;
                bean.seasonCode = orderLine.seasonCode;
                bean.colorBlocked = orderLine.colorBlocked ? 1 : 0;
                bean.whp = orderLine.unitPrice;
                bean.gots = orderLine.gots;
                bean.recycled = orderLine.recycled;
                bean.organic = orderLine.organic;
                bean.ecovero = orderLine.ecovero;
                bean.oekotex = orderLine.oekotex;
                bean.ocsno = orderLine.ocsno || '';
                bean.grsno = orderLine.grsno || '';
                break;
            default:
            // code block
        }
        return bean;
    };
    return StyleBean;
}());
export { StyleBean };
//# sourceMappingURL=Beans.js.map